import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Check, Zap, Sparkles, Clock } from 'lucide-react';
import { Button } from './Button';
import { offerIncludes } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-stone-100 border-y border-stone-200 scroll-mt-8" data-id="element-190" data-mp="1ja0eo2sldvlt">
      <div className="max-w-3xl mx-auto" data-id="element-191" data-mp="1na0rxk3yg0ra">
        <div className="text-center mb-10" data-id="element-192" data-mp="1s9n9u6uqa56f">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-stone-800" data-id="element-193" data-mp="1s8c1ruu92b9i">
            Your Complete Offer Today
          </h2>
          <p className="text-rose-800 text-sm md:text-base" data-id="element-194" data-mp="1x6vss9npad8q">
            Everything You Need to Teach With More Structure, Clarity and
            Confidence
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border-2 border-rose-700 rounded-3xl p-1 relative shadow-2xl shadow-rose-900/10" data-id="element-195" data-mp="2ws4vn4krbhg">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-rose-900 text-white font-bold px-5 py-1.5 rounded-full uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-196" data-mp="17stjjnwaet43">
            <Sparkles size={14} aria-hidden="true" data-id="element-197" data-mp="20hr3rwk26zzh" /> Complete System
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-10 text-center" data-id="element-198" data-mp="1vgl5lj7mqkik">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-rose-700 mb-3" data-id="element-199" data-mp="1rg1b6nefxv04">
              Makeup Instructor Ready Includes
            </h3>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-stone-100 border border-stone-200 rounded-xl p-4" data-id="element-200" data-mp="k3r2ah5kf2a4">
              {offerIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-stone-600" data-id="element-201" data-mp="hit698mkbw81">
                  <Check size={16} className="text-rose-700 shrink-0 mt-0.5" aria-hidden="true" data-id="element-202" data-mp="mery5673nwd7" />
                  <span data-id="element-203" data-mp="ch3rbhw7yyeo">{item}</span>
                </li>)}
            </ul>

            <div className="mb-4" data-id="element-204" data-mp="3uvw9uwgt979r">
              <span className="text-lg text-stone-500 line-through block mb-1" data-id="element-205" data-mp="3uuti6mbnz0ss">
                Regular Price: $137
              </span>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-206" data-mp="3kz06t69oldcl">
                <span className="text-2xl md:text-3xl text-stone-800" data-id="element-207" data-mp="3pxbhtkbpptwe">
                  YOUR PRICE TODAY:
                </span>
                <span className="text-4xl md:text-5xl font-bold text-rose-600" data-id="element-208" data-mp="3byv3b77lyz3p">
                  $27
                </span>
              </div>
            </div>

            <p className="text-sm text-stone-500 mb-5" data-id="element-209" data-mp="2xb3ayrwh49er">
              One payment. Instant digital access. No shipping. No waiting.
            </p>

            <p className="inline-flex items-center gap-2 bg-rose-900 text-white text-xs font-bold uppercase tracking-wider rounded-full px-4 py-2 mb-6" data-id="element-210" data-mp="2sdbk817ketc5">
              <Clock size={14} aria-hidden="true" data-id="element-211" data-mp="31cye81xyswv6" /> Launch pricing ends in 24
              hours
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-212" data-mp="3g9friyppslkd">
              GET MAKEUP INSTRUCTOR READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone-500" data-id="element-213" data-mp="3l05uk5ao4cbw">
              <span className="flex items-center gap-1.5" data-id="element-214" data-mp="2ujejntgyc6y">
                <Lock size={12} className="text-rose-700" aria-hidden="true" data-id="element-215" data-mp="2syks0ezaxa5" />{' '}
                Safe Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216" data-mp="hym5ajzb0xge">
                <Zap size={12} className="text-rose-700" aria-hidden="true" data-id="element-217" data-mp="hvzywno5gnzr" />{' '}
                Instant Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218" data-mp="qqo5ch5gobq5">
                <Shield size={12} className="text-rose-700" aria-hidden="true" data-id="element-219" data-mp="qr65hov8va3c" />{' '}
                7-Day Guarantee
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}